import BaseListagem from "components/BaseListagem";
import Pessoa from "model/administracao/cadastro/Pessoa";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ColetaService from "service/transportes/ColetaService";
import { converterDataHora } from "utils/convert";
import { DateMatchModeOptions, IdMatchModeOptions, NumberMatchModeOptions, TextMatchModeOptions, dateRangeFilterTemplate, filterApplyTemplate, numberFilterTemplate } from "utils/filterUtils";

const coletaService = new ColetaService();

export default function ColetaListagem() {

    useEffect(() => {
        coletaService.clientes().then((data)=>{
            setClientes(data);
        }).catch(err=>{
            console.log(err);
        })
    }, []);
    

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Coletas');

    const [clientes, setClientes] = useState<Pessoa[]>([]);

    const defaultFilters: DataTableFilterMeta = {
        numeroColeta: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataPrevista: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        cliente: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        estado: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.CONTAINS,
                }
            ],
            operator: FilterOperator.AND
        },
        cidade: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.CONTAINS,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    const clienteFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={clientes} 
            onChange={(e) => options.filterCallback(e.value)} 
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    return (

        <BaseListagem ordenacao="numero,ASC" service={coletaService} urlService="/coleta" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="coleta" >
            <Column field="numero" header="Número" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterElement={numberFilterTemplate} />
            <Column field="dataPrevista" body={(rowData)=> converterDataHora(rowData.dataPrevista)} header="Data" filter showFilterOperator={false} showAddButton={false} showFilterMatchModes={false} filterPlaceholder="Escreva o filtro"
                filterApply={filterApplyTemplate} filterElement={dateRangeFilterTemplate} />
            <Column field="cliente.nome" header="Cliente" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="cliente"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={clienteFilterTemplate} />
            <Column field="endereco.estado" header="Estado" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="estado"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterElement={numberFilterTemplate} />
            <Column field="endereco.cidade" header="Cidade" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="cidade"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterElement={numberFilterTemplate} />
        </BaseListagem>
    )
}